var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lucky"
  }, [_c('n-currency', {
    ref: "nCurrencyRef",
    attrs: {
      "isShowKey": false,
      "isShowTap": false
    }
  }), _c('div', {
    staticClass: "lucky-body page-body"
  }, [_c('div', {
    staticClass: "lucky-main page-main"
  }, [_c('div', {
    staticClass: "dan-maku"
  }, [_c('m-danmaku', {
    ref: "mDanmakuRef"
  })], 1), _c('div', {
    ref: "resultCoinCoincotainerRef",
    staticClass: "luckyTable-coin-coincotainer"
  }), _c('div', {
    staticClass: "lucky-con",
    style: {
      backgroundImage: `url(${require(`@images/tapcoin/lucky/lucky-bg.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "luckyTable"
  }, [_c('div', {
    staticClass: "luckyTable-m"
  }), _c('div', {
    staticClass: "luckyTable-bg",
    style: {
      backgroundImage: `url(${require(`@images/tapcoin/lucky/lucky-item-bg.png`)})`
    }
  }), _c('div', {
    ref: "luckyTableAdroinRef",
    staticClass: "luckyTable-adroin",
    class: _vm.isStartLucky && 'active',
    style: {
      backgroundImage: `url(${require(`@images/${this.theme}/lucky/light1.png`)})`
    }
  }), _vm.isLoadingLuckyList ? _c('div', {
    staticClass: "luckyTable-loading"
  }) : [_vm.prizeList && _vm.prizeList.length > 0 ? _c('div', {
    staticClass: "luckyTable-main",
    attrs: {
      "id": "luckyTableMain"
    }
  }, [_c('lucky-wheel', {
    ref: "vueLuckywheel",
    attrs: {
      "prize-index": _vm.prizeIndex
    },
    on: {
      "get-prize": _vm.onStart,
      "game-over": _vm.onResult
    }
  }, _vm._l(_vm.prizeList, function (prize, index) {
    return _c('lucky-wheel-item', {
      key: index
    }, [_c('div', {
      staticClass: "luckyTable-item"
    }, [_c('div', {
      staticClass: "luckyTable__icon",
      class: prize.type,
      style: {
        backgroundImage: `url(${require(`@images/${_vm.theme}/lucky/${prize.type}.png`)})`
      }
    }), _c('div', {
      staticClass: "luckyTable__num"
    }, [_vm._v(_vm._s(_vm._f("fmt_pre")(prize.value)))])])]);
  }), 1)], 1) : _vm._e()]], 2)]), _c('div', {
    staticClass: "lucky-btns"
  }, [_c('div', {
    staticClass: "lucky-btns-main"
  }, [_c('div', {
    staticClass: "lucky-btn",
    class: (!_vm.isFlag || _vm.luckyInfo.stock.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.stock.price_stock || _vm.luckyInfo.stock.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.stock.price_coin) && 'active',
    style: {
      background: `url(${require(`@images/${_vm.theme}/new/machine/machine-btn2-bg.png`)}) center/auto 100% no-repeat`
    },
    on: {
      "click": function ($event) {
        return _vm.onStart('stock');
      }
    }
  }, [_vm.luckyInfo?.count_options?.length > 1 && _vm.luckyList && _vm.luckyList[0] ? _c('div', {
    staticClass: "lucky-magni",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.setCountOption('stock');
      }
    }
  }, [_c('div', {
    staticClass: "lucky-magni-main"
  }, [_vm._v("x" + _vm._s(_vm.stockSelectCountOptions))])]) : _vm._e(), _c('div', {
    staticClass: "lucky-btn-main",
    style: {
      background: `url(${require(`@images/${_vm.theme}/lucky/lucky-btn2.png`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "lucky-btn__title"
  }, [_vm._v("SPIN")]), !_vm.isstockLoading ? _c('div', {
    staticClass: "lucky-btn__value"
  }, [_vm.luckyInfo.stock.price_stock > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPSTOCK.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.stock.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.stock.price_stock ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.luckyInfo ? _vm.fmt_pre(_vm.luckyInfo.stock.price_stock) : "--"))])]) : _vm._e(), _vm.luckyInfo.stock.price_stock > 0 && _vm.luckyInfo.stock.price_coin > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.stock.price_coin > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPCOINS.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.stock.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.stock.price_coin ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.stock.price_coin)))])]) : _vm._e(), _vm.luckyInfo.stock.price_stock <= 0 && _vm.luckyInfo.stock.price_coin <= 0 ? _c('span', [_vm._v("--")]) : _vm._e()], 2) : _c('div', {
    staticClass: "lucky-btn__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })])])]), _c('div', {
    staticClass: "lucky-btn",
    class: (!_vm.isFlag || _vm.luckyInfo.tap.price_stock > 0 && _vm.userData.tap < _vm.luckyInfo.tap.price_stock || _vm.luckyInfo.tap.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.tap.price_coin || _vm.luckyInfo.tap.price_tap > 0 && _vm.assetsList && _vm.assetsList?.[3].balance < _vm.luckyInfo.tap.price_tap) && 'active',
    style: {
      background: `url(${require(`@images/${_vm.theme}/new/machine/machine-btn2-bg.png`)}) center/auto 100% no-repeat`
    },
    on: {
      "click": function ($event) {
        return _vm.onStart('tap');
      }
    }
  }, [_vm.luckyInfo?.count_options?.length > 1 && _vm.luckyList && _vm.luckyList[0] ? _c('div', {
    staticClass: "lucky-magni",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.setCountOption('tap');
      }
    }
  }, [_c('div', {
    staticClass: "lucky-magni-main"
  }, [_vm._v("x" + _vm._s(_vm.tapSelectCountOptions))])]) : _vm._e(), _c('div', {
    staticClass: "lucky-btn-main",
    style: {
      background: `url(${require(`@images/${_vm.theme}/lucky/lucky-btn2.png`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "lucky-btn__title"
  }, [_vm._v("SPIN")]), !_vm.istapLoading ? _c('div', {
    staticClass: "lucky-btn__value"
  }, [_vm.luckyInfo.tap.price_stock > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPSTOCK.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.tap.price_stock ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.luckyInfo ? _vm.fmt_pre(_vm.luckyInfo.stotapck.price_stock) : "--"))])]) : _vm._e(), _vm.luckyInfo.tap.price_stock > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.tap.price_coin > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPCOINS.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.tap.price_coin ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.tap.price_coin)))])]) : _vm._e(), _vm.luckyInfo.tap.price_coin > 0 || _vm.luckyInfo.tap.price_coin > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.tap.price_tap > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAP.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_tap > 0 && _vm.assetsList && _vm.assetsList?.[3].balance < _vm.luckyInfo.tap.price_tap ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.tap.price_tap)))])]) : _vm._e()], 2) : _c('div', {
    staticClass: "lucky-btn__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })])])])]), _c('div', {
    staticClass: "lucky-balance"
  }, [_c('n-currency-two', {
    ref: "nCurrencyTwoRef",
    attrs: {
      "itemBg": "#0e2043",
      "isShowCoin": false,
      "showkeyFnc": () => _vm.popSignShow = true,
      "isShowTap": true,
      "showTapFnc": () => _vm.popUsdInviteShow = true
    }
  })], 1)]), _c('div', {
    staticClass: "record"
  }, [_c('div', {
    staticClass: "record__title"
  }, [_vm._v(_vm._s(_vm.$lang("Records")))]), _c('div', {
    staticClass: "record-list"
  }, [_vm.luckyLoading ? [_c('div', {
    staticClass: "loadingList"
  }, [_c('div', {
    staticClass: "loading-list"
  }, _vm._l(3, function (_) {
    return _c('div');
  }), 0)])] : _vm._e(), !_vm.luckyLogs ? [_c('div', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.$lang("There's nothing here")))])] : _vm._l(_vm.luckyLogs, function (item, index) {
    return _c('div', {
      staticClass: "record-item"
    }, [_c('div', {
      staticClass: "record-item__icon",
      class: item.item_currency
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/lucky/${item.item_currency.toLowerCase()}.png`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "record-item__num"
    }, [_vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.draw_count * item.item_amount, 3, true, true)) + " "), _c('span')])]);
  })], 2)])])]), _c('pop-usd-sign', {
    attrs: {
      "show": _vm.popSignShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popSignShow = $event;
      },
      "skip": () => (_vm.popSignShow = false, _vm.popUsdInviteShow = true)
    }
  }), _c('pop-usd-invite', {
    attrs: {
      "show": _vm.popUsdInviteShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popUsdInviteShow = $event;
      },
      "skip": () => (_vm.popUsdInviteShow = false, _vm.popSignShow = true)
    }
  }), _c('pop-prompt2', {
    attrs: {
      "className": "popGamerewardBox",
      "isClose": false,
      "show": _vm.isPopResult,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": "Go head"
    },
    on: {
      "update:show": function ($event) {
        _vm.isPopResult = $event;
      },
      "confirm": () => _vm.isPopResult = false
    },
    scopedSlots: _vm._u([{
      key: "limit",
      fn: function () {
        return [_vm.selectRow.currency != 'TAPGIFTSHARD' ? _c('div', {
          staticClass: "pop-gamereward-balance"
        }, [_c('span', [_vm._v("Balance: ")]), _vm.selectRow.currency == 'TAPCOINS' ? _c('img', {
          attrs: {
            "src": require(`@images/${_vm.theme}/new/TAPCOINS-small.png`),
            "alt": ""
          }
        }) : _vm.selectRow.currency == 'TAPSTOCK' ? _c('img', {
          attrs: {
            "src": require(`@images/${_vm.theme}/new/TAPSTOCK-small.png`),
            "alt": ""
          }
        }) : _vm.selectRow.currency == 'USDT' ? _c('img', {
          attrs: {
            "src": require(`@images/${_vm.theme}/new/USDT-small.png`),
            "alt": ""
          }
        }) : _vm._e(), [_vm.selectRow.currency == 'TAPCOINS' ? [!_vm.isGameRewardBalanceAnim ? [_vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.userData.coin)) + " ")] : _c('m-count-up', {
          attrs: {
            "endVal": Number(_vm.userData.coin)
          }
        })] : _vm.selectRow.currency == 'TAPSTOCK' ? [!_vm.isGameRewardBalanceAnim ? [_vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.userData.stock)) + " ")] : _c('m-count-up', {
          attrs: {
            "endVal": Number(_vm.userData.stock)
          }
        })] : _vm.selectRow.currency == 'USDT' ? [!_vm.isGameRewardBalanceAnim ? [_vm._v(" " + _vm._s(_vm._f("fmt_usdtPre")(_vm.assetsList[1].balance)) + " ")] : _c('m-count-up', {
          attrs: {
            "endVal": Number(_vm.assetsList[1].balance),
            "options": {
              decimalPlaces: 5
            }
          }
        })] : _vm._e()]], 2) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pop-gamereward"
  }, [_c('div', {
    staticClass: "pop-gamereward__title"
  }, [_vm._v("Congratulations")]), _vm.selectRow ? _c('div', {
    staticClass: "pop-gamereward-list"
  }, [_c('div', {
    staticClass: "pop-gamereward-item"
  }, [_vm.selectRow.currency == 'TAPGIFTSHARD' ? _c('div', {
    staticClass: "pop-gamereward-item-giftshard"
  }, [_c('div', {
    staticClass: "pop-gamereward-item__title"
  }, [_vm._v("Shard Rewards(+"), _c('m-count-up', {
    attrs: {
      "endVal": Number(Object.values(_vm.selectRow.amount).reduce((sum, item) => sum + Number(item.amount || 0), 0))
    }
  }), _vm._v(")")], 1), _c('transition-group', {
    staticClass: "pop-gamereward-item-scroll",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterGameGiftShard
    }
  }, _vm._l(_vm.selectRow.amount, function (val, ke, index) {
    return _c('div', {
      key: `gamereward${index}`,
      staticClass: "pop-gamereward-item-chip",
      attrs: {
        "data-index": index <= 50 ? index + 0.2 : 0
      }
    }, [_c('div', {
      staticClass: "pop-gamereward-item-chip-icon"
    }, [_c('img', {
      attrs: {
        "src": val.thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "pop-gamereward-item__name"
    }, [_c('span', [_vm._v(_vm._s(val.name))])]), _c('div', {
      staticClass: "pop-gamereward-item__num"
    }, [_vm._v("+"), _c('m-count-up', {
      attrs: {
        "endVal": Number(val.amount)
      }
    })], 1)]);
  }), 0)], 1) : [_c('div', {
    staticClass: "pop-gamereward-item-price"
  }, [_vm.selectRow.currency == 'TAPCOINS' ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPCOINS-small.png`),
      "alt": ""
    }
  }) : _vm.selectRow.currency == 'TAPSTOCK' ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPSTOCK-small.png`),
      "alt": ""
    }
  }) : _vm.selectRow.currency == 'USDT' ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/USDT-small.png`),
      "alt": ""
    }
  }) : _vm._e(), _c('span', [_vm._v("+"), _vm.selectRow.currency == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.selectRow.amount)))] : [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.selectRow.amount, 3, true, false)))]], 2)])]], 2)]) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };